module.exports = __webpack_public_path__ + "static/img/m7.6846406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m7.jpg
// module id = eHtm
// module chunks = 1